const atencionSinTurnoInitialState = {
    atencionSinTurno: {
      loading: false,
      error: null,
      data: null,      
    },
  };
  
  export default atencionSinTurnoInitialState;
  